export const MEETING_ATTENDEE_TYPES = {
  MANDATORY: 'MANDATORY',
  OWNER: 'OWNER',
  OPTIONAL: 'OPTIONAL',
};
